module.exports = require("@ember-data/model");